import React, { useState, useEffect, useContext, useMemo } from 'react';
import { useDidUpdate } from '../../../../hooks/useUpdate';
import axios from "../../../../axios/index"

// context
import { UserContext } from '../../../Context/UserContextProvider';


import ShowProfileModal from '../../DashboardFileManagement/CardDetail/ShowProfileModal';
import DashboardHeader from '../../DashboardReuseAbleComponents/DashboardHeader';
import DashboardSideMenu from '../../DashboardReuseAbleComponents/DashboardSideMenu';
import StaffManagmentFiles from './StaffManagmentFiles';
import StaffManagmentDoughnutCharts from '../StaffManagmentCharts/StaffManagmentDoughnutCharts';
import StaffManagmentLineCharts from '../StaffManagmentCharts/StaffManagmentLineCharts';
import { Dropdown } from "react-bootstrap";

// Styles
import styles from "./../StaffManagment.module.css";
import Dstyles from "../../DashboardFileManagement/DashboardFileManagement.module.css"

// Images
import arrowIcon from "./../../../../assets/img/DashboardICons/ArrowRounded.svg";
import arrowDown from "./../../../../assets/img/DashboardICons/ArrowDown.svg";
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

const StaffDataStatistic = () => {
    const { userToken } = useContext(UserContext);
    const [isLoading, setIsLoading] = useState(true);
    const [modalShow, setModalShow] = useState(false);
    const [dashboardData, setDashboardData] = useState([])
    const [lineChart, setLineChart] = useState({
        days: "",
        values: ""
    })
    const [selectDayLine, setSelectDayLine] = useState("ده روز پیش");
    const [filterChart, setFilterChart] = useState({
        sale: true,
        rent: false
    });
    const history = useHistory();

    useMemo(() => dashboardData, [dashboardData])

    useEffect(() => {
        const dataHandler = async () => {
            // setIsLoading(true)
            const getData = await axios.get(
                "Admin/AdminPageData",
                {
                    headers: { authorization: "Bearer " + userToken },
                }
            );
            const getChartData = await axios.get(
                `Admin/FileChartData?type=${filterChart.sale ? "فروش" : filterChart.rent === true && "رهن"}`,
                {
                    headers: { authorization: "Bearer " + userToken },
                }
            );
            const dashboardData = getData.data.data;
            const chartData = getChartData.data.data;
            setDashboardData(dashboardData)
            setLineChart((prev) => {
                return { ...prev, days: JSON.parse(chartData?.days), values: JSON.parse(chartData?.values) };
            });
            setIsLoading(false)
        }

        dataHandler()
    }, [userToken, filterChart.sale, filterChart.rent])

    useDidUpdate(() => {
        const dataHandler = async () => {
            // setIsLoading(true)
            const getDayId = selectDayLine === "ده روز پیش" ? 10 : selectDayLine === "بیست روز پیش" ? 20 : selectDayLine === "هفت روز پیش" ? 7 : selectDayLine === "یک روز پیش" && 1;
            const getChartData = await axios.get(
                `Admin/FileChartData?day=${getDayId}&type=${filterChart.sale ? "فروش" : filterChart.rent === true && "رهن"}`,
                {
                    headers: { authorization: "Bearer " + userToken },
                }
            );
            const chartData = getChartData.data.data;
            const days = JSON.parse(chartData?.days)
            const values = JSON.parse(chartData?.values)
            const reversedDates = days.reverse();
            setLineChart((prev) => {
                return { ...prev, days: reversedDates, values: values };
            });
            // setIsLoading(false)
        }

        dataHandler()
    }, [userToken, selectDayLine])

    const dataLineChartConfig = {
        borderColor: '#21409A',
        backgroundColor: '#21409A',
        lineTension: 0.4,
        animation: true,
        pointRadius: 0,
    }

    const dataSaleLineChart = {
        responsive: true,
        labels: lineChart?.days,
        datasets: [
            {
                data: lineChart?.values,
                ...dataLineChartConfig
            }
        ],
    };

    const dataRentLineChart = {
        responsive: true,
        labels: lineChart?.days,
        datasets: [
            {
                data: lineChart?.values,
                ...dataLineChartConfig
            }
        ],
    };

    const selectDayLineHandler = (value) => {
        setSelectDayLine(value)
    }

    const changeFilterChartHandler = (name) => {
        if (name === "sale") {
            setFilterChart((prev) => {
                return { ...prev, sale: true, rent: false };
            });
        } else if (name === "rent") {
            setFilterChart((prev) => {
                return { ...prev, rent: true, sale: false };
            });
        }
    }

    return (
        <>

            <style type="text/css">
                {`
                    .dropdown-toggle {
                        height: 35px;
                        font-size: 14px !important;
                        background: #f9f9f9;
                        border: none !important;
                        border-radius: 34px;
                        margin-left: 0.75rem;
                        color: #1D1D1D;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    }
                    
                    .dropdown-toggle:after,
                    .btn-success:after {
                        content: none;
                    }
                    
                    .btn-success {
                        background: #f9f9f9 !important;
                        color: #1D1D1D !important;
                        box-shadow: none !important;
                    }
                
                    .dropdown-menu {
                        overflow-y: scroll;
                        background: #F9F9F9;
                        border: 1px solid #E1E1E1;
                        border-radius: 34px;
                    }

                    .dropdown-toggle:hover {
                        background: #f4f4f4;
                        color: #1D1D1D;
                        border-color: #e5e5e5;
                        border: 1px solid #e2e2e2;
                    }
                
                   .dropdown-menu::-webkit-scrollbar{
                    width: 3px;
                    height: 50px;
                    }
                    
                    .dropdown-menu::-webkit-scrollbar-track {
                        background: transparent;
                        margin-block: 10px;
                    }
                
                    .dropdown-menu::-webkit-scrollbar-thumb {
                        background: #B4B4B4;
                        border-radius: 20px;
                    }
                
                    .dropdown-item {
                        margin: .5rem 0;
                        padding: .5rem .5rem .5rem 0;
                        display: flex;
                        align-items: center;
                        justify-content: flex-start;
                        font-weight: 400;
                        font-size: 14px;
                        line-height: 22px;
                        color: #1D1D1D;
                    }
                
                    .dropdown-item:hover {
                        background: #E7EAF4 !important;
                        border-radius: 24px !important;
                        font-weight: 400;
                        font-size: 14px;
                        line-height: 22px;
                        color: #1D1D1D;
                    }
    `}
            </style>

            <ShowProfileModal
                show={modalShow}
                onHide={() => setModalShow(false)}
            />

            {isLoading ? (
                <div className={Dstyles.loader_container}>
                    <div className={Dstyles.spinner}></div>
                </div>
            )
                : (
                    <div className='container-fluid'>
                        <div className='row'>
                            <div className="col-md-9" >
                                <div className={`my-3 pb-4 px-0 ${styles.file_cards_container}`}>
                                    <DashboardHeader onClick={() => setModalShow(true)} class="px-0" />

                                    <div
                                        className="d-flex justify-content-md-between justify-content-center flex-wrap align-items-center mt-4 mx-4 px-2"
                                        dir="rtl"
                                    >
                                        <div className='d-flex align-items-center justify-content-start flex-wrap mt-2 mb-2'>
                                            <a href='#' onClick={history.goBack}><img className='ms-2' src={arrowIcon} alt="icon" /></a>
                                            <div className={styles.text1}>
                                                آمار داده‌ ها
                                            </div>
                                        </div>
                                    </div>

                                    {/* Total Staff Managment Info */}

                                    <StaffManagmentFiles dashboardData={dashboardData?.estateFileStatus} userCount={dashboardData?.personnelCount} />
                                    <StaffManagmentDoughnutCharts dashboardData={dashboardData?.estateFileChart} />
                                    <div className="pt-3">
                                        <StaffManagmentLineCharts
                                            maximumYScaleLineChart={80}
                                            dataLineTooltipValue={filterChart.sale ? "فروش" : filterChart.rent ? "رهن و اجاره" : null}
                                            dataLineChart={filterChart.sale ? dataSaleLineChart : filterChart.rent ? dataRentLineChart : null}
                                        >
                                            <div className={`d-flex align-items-center justify-content-center`}>
                                                <div className={`w-100 d-flex justify-content-between`}>
                                                    <h5 className={`m-0 ${styles.total_title_staffline_chart_box}`}> آمار فایل ها </h5>
                                                </div>

                                                <div>
                                                    <Dropdown dir='rtl' onSelect={selectDayLineHandler}>
                                                        <Dropdown.Toggle variant="success" id="dropdown-basic">
                                                            {selectDayLine}
                                                            <img className='me-3' src={arrowDown} alt="icon" />
                                                        </Dropdown.Toggle>

                                                        <Dropdown.Menu>
                                                            <Dropdown.Item eventKey="بیست روز پیش">
                                                                بیست روز پیش
                                                            </Dropdown.Item>
                                                            <Dropdown.Item eventKey="ده روز پیش">
                                                                ده روز پیش
                                                            </Dropdown.Item>
                                                            <Dropdown.Item eventKey="هفت روز پیش">
                                                                هفت روز پیش
                                                            </Dropdown.Item>
                                                            <Dropdown.Item eventKey="یک روز پیش">
                                                                یک روز پیش
                                                            </Dropdown.Item>
                                                        </Dropdown.Menu>
                                                    </Dropdown>
                                                </div>
                                            </div>

                                            <div dir="rtl" className={`d-flex align-items-center justify-content-start mt-4 mb-5 ms-auto ${styles.total_filter_chart_box}`}>
                                                <div className={`px-4 ${styles.sale_filter_box} ${filterChart.sale ? styles.filter_chart_box_active : styles.filter_chart_box_deactive}`} onClick={() => changeFilterChartHandler("sale")} role="button">
                                                    فروش
                                                </div>
                                                <div className={`px-4 ${styles.rent_filter_box} ${filterChart.rent ? styles.filter_chart_box_active : styles.filter_chart_box_deactive}`} onClick={() => changeFilterChartHandler("rent")} role="button">
                                                    رهن و اجاره
                                                </div>
                                            </div>
                                        </StaffManagmentLineCharts>
                                    </div>

                                </div>
                            </div>
                            <div className='col-md-3'>
                                {/* sideMenu starts */}
                                <DashboardSideMenu managePersonal manageDataStatistic />
                                {/* sideMenu ends */}
                            </div>
                        </div>
                    </div>
                )}
        </>
    )
}

export default React.memo(StaffDataStatistic);
